export const envConfigs = {
  int: {
    issuer: "https://oauth.int.ws.sonos.com/oauth/v4/okta-widget",
    authorizeUrl: "https://oauth.int.ws.sonos.com/oauth/v4/okta-widget/authorize",
    tokenUrl: "https://oauth.int.ws.sonos.com/oauth/v4/okta-widget/token",
    clientId: "b0701d45-136d-4a07-b84c-fd3f3826a708",
    redirectUri: "https://idassets-int.sonos.com/welcome",
    responseMode: "fragment",
    grantType: "authorization_code",
    pkce: true,
    tokenManager: {
      storage: "sessionStorage",
      storageKey: "okta-token-storage-int",
    },
    logoutRedirect: "https://login-int.sonos.com",
  },
  test: {
    issuer: "https://oauth.test.ws.sonos.com/oauth/v4/okta-widget",
    authorizeUrl: "https://oauth.test.ws.sonos.com/oauth/v4/okta-widget/authorize",
    tokenUrl: "https://oauth.test.ws.sonos.com/oauth/v4/okta-widget/token",
    clientId: "a13e4e3a-711f-4188-8ab5-46ac9257ac17",
    redirectUri: "https://idassets-test.sonos.com/welcome",
    responseMode: "fragment",
    grantType: "authorization_code",
    pkce: true,
    tokenManager: {
      storage: "sessionStorage",
      storageKey: "okta-token-storage-test",
    },
    logoutRedirect: "https://login-test.sonos.com",
  },
  perf: {
    issuer: "https://oauth.perf.ws.sonos.com/oauth/v4/okta-widget",
    authorizeUrl: "https://oauth.perf.ws.sonos.com/oauth/v4/okta-widget/authorize",
    tokenUrl: "https://oauth.perf.ws.sonos.com/oauth/v4/okta-widget/token",
    clientId: "b537485c-0c07-4d58-a165-641fbeb85d53",
    redirectUri: "https://idassets-perf.sonos.com/welcome",
    responseMode: "fragment",
    grantType: "authorization_code",
    pkce: true,
    tokenManager: {
      storage: "sessionStorage",
      storageKey: "okta-token-storage-perf",
    },
    logoutRedirect: "https://login-perf.sonos.com",
  },
  stage: {
    issuer: "https://oauth.stage.ws.sonos.com/oauth/v4/okta-widget",
    authorizeUrl: "https://oauth.stage.ws.sonos.com/oauth/v4/okta-widget/authorize",
    tokenUrl: "https://oauth.stage.ws.sonos.com/oauth/v4/okta-widget/token",
    clientId: "773841d0-d253-4344-909a-d0ea117d1887",
    redirectUri: "https://idassets-stage.sonos.com/welcome",
    responseMode: "fragment",
    grantType: "authorization_code",
    pkce: true,
    tokenManager: {
      storage: "sessionStorage",
      storageKey: "okta-token-storage-stage",
    },
    logoutRedirect: "https://login-stage.sonos.com",
  },
  prod: {
    issuer: "https://oauth.ws.sonos.com/oauth/v4/okta-widget",
    authorizeUrl: "https://oauth.ws.sonos.com/oauth/v4/okta-widget/authorize",
    tokenUrl: "https://oauth.ws.sonos.com/oauth/v4/okta-widget/token",
    clientId: "a091749f-242b-4d2c-90b6-c368d9b9ce34",
    redirectUri: "https://idassets.sonos.com/welcome",
    responseMode: "fragment",
    grantType: "authorization_code",
    pkce: true,
    tokenManager: {
      storage: "sessionStorage",
      storageKey: "okta-token-storage-prod",
    },
    logoutRedirect: "https://login.sonos.com",
  },
  local: {
    issuer: "https://oauth.int.ws.sonos.com/oauth/v4/okta-widget",
    authorizeUrl: "https://oauth.int.ws.sonos.com/oauth/v4/okta-widget/authorize",
    tokenUrl: "https://oauth.int.ws.sonos.com/oauth/v4/okta-widget/token",
    clientId: "b0701d45-136d-4a07-b84c-fd3f3826a708",
    redirectUri: "http://localhost:8080/welcome",
    responseMode: "fragment",
    grantType: "authorization_code",
    pkce: true,
    tokenManager: {
      storage: "sessionStorage",
      storageKey: "okta-token-storage-local",
    },
    logoutRedirect: "https://login-int.sonos.com",
  },
};

export function getQueryParams() {
  // Okta appends a query string regardless of whether the redirect URL already includes one.
  // The conditional below turns the second ? into an & to handle the condition where a query
  // string is appended incorrectly.
  // example: https://idassets.sonos.com/?tier=test?type_hint=EMAIL_VERIFICATION&session_hint=AUTHENTICATED&login_hint=scott.irvin%2Btest1000%40sonos.com
  var params = "";
  var paramSegments = window.location.search.split("?");
  for (let i = 0; i < paramSegments.length; i++) {
    params += paramSegments[i];
    if (i < paramSegments.length - 1) {
      params += "&";
    }
  }

  return new URLSearchParams(params);
}

function getEnvFromDomain(domain) {
  if (domain === "localhost") {
    return "local";
  }

  const subdomain = domain.split(".")[0];
  let subdomainEnv = subdomain.split("-");
  let env = "prod";

  if (subdomainEnv.length > 1) {
    env = subdomainEnv[1].toLocaleLowerCase();
  }

  return env;
}

export function getEnvironment() {
  try {
    var domain = window.location.hostname;
    var params = getQueryParams();

    if (params.has("tier")) {
      return params
        .get("tier")
        .trim()
        .toLocaleLowerCase();
    } else {
      return getEnvFromDomain(domain);
    }
  } catch (e) {
    console.log(e);
  }
}
